export default __webpack_public_path__ + "static/media/yudh-blck.8486f8cf.jpeg";